"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreferredLanguage = void 0;
var acceptLanguage = __importStar(require("accept-language-parser"));
function getPreferredLanguage(languages, acceptedLanguages) {
    if (typeof acceptedLanguages === 'string') {
        var lang_1 = acceptLanguage.pick(Array.from(languages), acceptedLanguages, { loose: true });
        return lang_1 === null ? undefined : lang_1;
    }
    // Treat each language as equally important (quality = 1.0 out of 1.0)
    var accepted = acceptedLanguages.map(function (lng) { return ({ code: lng, quality: 1.0 }); });
    var lang = acceptLanguage.pick(Array.from(languages), accepted, { loose: true });
    return lang === null ? undefined : lang;
}
exports.getPreferredLanguage = getPreferredLanguage;
